import React, { useState } from 'react';
import cn from 'clsx';

import {
  ThumbsDownSolidIcon,
  ThumbsUpSolidIcon
} from '../../../../shared/icons/icons';

import styles from './review-feedback.scss';

interface ReviewFeedbackProps {
  helpfulCount?: number;
  id: string;
  isFeedbackSubmitted?: boolean;
  isReportLabel?: boolean;
  notHelpfulCount?: number;
  onHelpfulClick?: (id: string, isHelpful: boolean) => void;
}

function ReviewFeedback(props: ReviewFeedbackProps) {
  const {
    helpfulCount,
    id,
    isFeedbackSubmitted,
    isReportLabel = false,
    notHelpfulCount,
    onHelpfulClick
  } = props;

  const [hasSubmittedFeedback, setHasSubmittedFeedback] =
    useState(isFeedbackSubmitted);

  function submitHelpfulFeedback() {
    setHasSubmittedFeedback(true);
    if (onHelpfulClick) {
      onHelpfulClick(id, true);
    }
  }

  function submitNotHelpfulFeedback() {
    setHasSubmittedFeedback(true);
    if (onHelpfulClick) {
      onHelpfulClick(id, false);
    }
  }
  return (
    <div className={cn(styles['container'], 'review-feedback')}>
      {hasSubmittedFeedback ? (
        <span className={styles['helpful-message-thanks']}>
          Thank you for your feedback!
        </span>
      ) : (
        <>
          <span className={styles['helpful-message']}>
            Was this {isReportLabel ? 'report' : 'review'} helpful?
          </span>
          <div className={styles['helpful-feedback']}>
            <button
              aria-label="Submit feedback review helpful"
              className={cn(
                styles['feedback-button'],
                'review-feedback__feedback-button'
              )}
              onClick={submitHelpfulFeedback}
              type="button"
            >
              <ThumbsUpSolidIcon className={styles['feedback-icon']} />
              {helpfulCount}
            </button>

            <button
              aria-label="Submit feedback review not helpful"
              className={cn(
                styles['feedback-button'],
                'review-feedback__feedback-button'
              )}
              onClick={submitNotHelpfulFeedback}
              type="button"
            >
              <ThumbsDownSolidIcon className={styles['feedback-icon']} />
              {notHelpfulCount}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default ReviewFeedback;
